module.exports = __webpack_public_path__ + "img/icon_map_6_on_101.dad73059.png";